import { Outlet, useLocation } from "react-router-dom";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export default function DashboardLayout() {
  const location = useLocation();

  const segmentLabelMap = {
    newsletter: "Subscribers",
    registrations: "Account Registrations",
    blogs: "Blog Posts",
    create: "Create Post",
    edit: "Edit Post",
  };

  // Generate breadcrumb based on current path
  const getBreadcrumbs = () => {
    const path = location.pathname;

    if (path === "/dashboard") {
      return (
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbPage>Admin</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      );
    }

    // For other dashboard routes
    const segments = path.split("/").filter(Boolean);
    return (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink href="/dashboard/newsletter">Admin</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="capitalize">
              {segmentLabelMap[segments[segments.length - 1]] || segments[segments.length - 1]}
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    );
  };

  return (
    <SidebarProvider
      defaultOpen={true}
      style={{
        "--sidebar-width": "20rem",
        "--sidebar-width-icon": "5rem",
        "--sidebar-width-mobile": "20rem",
      }}>
      <div className="flex min-h-screen w-full">
        {/* Sidebar - now properly handles mobile with Sheet */}
        <AppSidebar />

        <div className="flex flex-1 flex-col">
          {/* Top bar with toggle and breadcrumb */}
          <header className="bg-background sticky top-0 z-10 flex h-16 items-center gap-4 border-b px-4 md:px-6">
            <SidebarTrigger className="shrink-0" />
            {getBreadcrumbs()}
            <div className="flex-1" />
          </header>

          {/* Main content */}
          <main className="bg-background flex-1">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
